(function (global, factory) {
    factory(require('jquery'))
}(this, (function ($) { 'use strict';

    global.OffCanvas = {
        options: {
            canvas: null,
        },
        menu: {
            close: function() {
                $('html, body, #content').css({ overflow: 'auto' });
                $('.row-off-canvas').removeClass('active');
                $('.row-off-canvas #' + OffCanvas.options.canvas).removeClass('active');
                OffCanvas.options.canvas = null;
            }
        },
        init: function() {
            $('[data-toggle="off-canvas-open"]').click(function () {
                OffCanvas.options.canvas = $(this).data('off-canvas');
                $('html, body, #content').css({ overflow: 'hidden' });
                $('.row-off-canvas #' + OffCanvas.options.canvas).addClass('active');
                $('.row-off-canvas').addClass('active');
            });
            $('[data-toggle="off-canvas-close"]').click(OffCanvas.menu.close);
            $('[data-bs-target="#modal-login"]').click(OffCanvas.menu.close);
            $(window).resize(OffCanvas.menu.close);
        }
    };

})));
